module.exports = __webpack_public_path__ + "static/media/largeFont.552dab45.png";